// /settings/shortcuts — «Клавиши»: полный список клавиш (ux.md «Табеля», раздел 8) — тот же,
// что в окне `?`.
import { createFileRoute } from '@tanstack/react-router';
import { ShortcutsPage } from '../../../features/settings/ShortcutsPage.tsx';

export const Route = createFileRoute('/_app/_settings/settings/shortcuts')({
  staticData: { crumb: 'Клавиши' },
  component: ShortcutsPage,
});
